export const HAS_ADMIN_PERMISSIONS = 'agentos.agentos_admin';
export const HAS_SUPER_ADMIN_PERMISSIONS = 'agentos.practices_admin';
export const CAN_ACCESS_ANALYTICS_DASHBOARD =
  'agentos.can_access_analytics_dashboard';

export enum ChatMode {
  REAL_TIME = 'REAL_TIME',
  VOICE = 'VOICE',
  TEXT = 'TEXT',
}

export const TENANT_DISPLAY_NAME: Record<string, string> = {
  CBS_EMBA_Spring_2025: 'CBS EMBA Spring 2025',
  '[Demo]External-LiFT': 'External-LiFT',
  '[Demo] First National Bank of Omaha': 'First National Bank of Omaha',
  '[Demo] HEB': 'H-E-B',
  '[Demo] iQuanti': 'iQuanti',
  '[Demo] Kantar Test': 'Kantar Test',
  '[Demo] LiFT-Sales': 'LiFT-Sales',
  '[Demo] Pathward': 'Pathward',
  '[Demo] SoulWhisperer': 'SoulWhisperer',
  '[DEMO] SRF': 'SRF',
  '[Event] Future of Work': 'Future of Work',
  '[Pilot]CJUSD': 'CJUSD',
  '[Pilot] Ericsson': 'Ericsson',
  '[Pilot] Kantar': 'Kantar',
  '[Pilot] Kantar AI Growth Coach Pilot': 'Growth Coach',
  '[Pilot] Kantar Communicating Transformation': 'Communicating Transformation',
  '[Pilot] Kantar ERG Leaders': 'Kantar ERG Leaders',
};
